import React from "react";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import SmartphoneIcon from "@mui/icons-material/SmartphoneOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import SmsIcon from "@mui/icons-material/SmsOutlined";
import FaxIcon from "@mui/icons-material/FaxOutlined";
import BusinessIcon from "@mui/icons-material/BusinessOutlined";
import DialpadIcon from "@mui/icons-material/DialpadOutlined";
import ContactInfoCard from "./contactInfoCard";

// Details of a contact from the company's external directory.
const ContactInfoExternal = (props) => {
    const { open, setOpen, contact, onCall, onEmail } = props;

    if (!contact || !open)
        return null;

    // A directory entry may lack whole blocks; read them defensively.
    const business = contact.numbers?.office || contact.number;
    const name = `${contact.firstName || ""} ${contact.lastName || ""}`.trim();
    const company = String(contact.company || "").trim();

    const sections = [
        {
            title: "Phone",
            rows: [
                { label: "Business", value: business, type: "phone", icon: <PhoneIcon /> },
                { label: "Mobile", value: contact.numbers?.mobile, type: "phone", icon: <SmartphoneIcon /> },
                { label: "SMS", value: contact.numbers?.sms, type: "phone", noCall: true, icon: <SmsIcon /> },
                { label: "Fax", value: contact.numbers?.fax, type: "phone", noCall: true, icon: <FaxIcon /> },
            ],
        },
        {
            title: "Speed dial",
            rows: [
                { label: "Speed dial code", value: contact.speedDial?.code, icon: <DialpadIcon /> },
                { label: "Speed dial number", value: contact.speedDial?.number, type: "phone", icon: <PhoneIcon /> },
            ],
        },
        {
            title: "Other",
            rows: [
                { label: "Email", value: contact.email, type: "email", icon: <EmailIcon /> },
                { label: "Company", value: company, icon: <BusinessIcon /> },
            ],
        },
    ];

    return (
        <ContactInfoCard
            open={open}
            onClose={() => setOpen(false)}
            name={name}
            subtitle={company ? `${company} · External contact` : "External contact"}
            number={business}
            sections={sections}
            // The speed dial number first, as in the list.
            callNumber={contact.speedDial?.number || business || contact.numbers?.mobile}
            onCall={onCall ? (number) => onCall(contact, number) : undefined}
            email={contact.email}
            onEmail={onEmail}
        />
    );
}

export default ContactInfoExternal;
